import { Component, effect, input, signal } from '@angular/core';
import { AnalyzeTestCaseResult } from '@shared/models/analyze';
@Component({
  selector: 'app-view-test-case',
  imports: [],
  templateUrl: './view-test-case.html',
})
export class ViewTestCase {
  data = input<AnalyzeTestCaseResult>();
  index = input<number>();
  isPassed = signal<boolean>(false);
  testCaseId = signal<string>('');
  inputValue = signal('');
  actualOutput = signal('');
  expectedOutput = signal('');
  executionTime = signal<number | null>(null);
  memoryUsed = signal<number | null>(null);
  status = signal<string>('');
  isExpanded = signal(false);

  constructor() {
    effect(() => {
      const data = this.data;
      if (data) {
        this.isPassed.set(data()!.isPassed);
        this.testCaseId.set(data()!.testCaseId);
        this.inputValue.set(data()!.input);
        this.actualOutput.set(data()!.actualOutput);
        this.expectedOutput.set(data()!.expectedOutput);
        this.executionTime.set(data()!.executionTime);
        this.memoryUsed.set(data()!.memoryUsed);
        this.status.set(data()!.status);
        this.isExpanded.set(false);
      }
    });
  }

  toggleExpand() {
    this.isExpanded.set(!this.isExpanded());
  }
}
